class CartRemoveButton extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      const cartContainer = this.closest('cart-drawer') || this.closest('cart-items')

      const itemBeingRemoved = this.closest('.cart__item')
      const variantBeingRemoved = itemBeingRemoved.getAttribute('variant_id')
      const qtyBeingRemoved = -itemBeingRemoved.getAttribute('qty')

      // const cartItem = this.closest('.cart-item')
      const gtm_item_name = itemBeingRemoved.querySelector('[name="gtm_item_name"]').getAttribute('value')
      const gtm_item_id = itemBeingRemoved.querySelector('[name="gtm_item_id"]').getAttribute('value')
      const gtm_item_variant = itemBeingRemoved.querySelector('[name="gtm_item_variant"]').getAttribute('value')
      const gtm_item_upc = itemBeingRemoved.querySelector('[name="gtm_item_upc"]').getAttribute('value')
      const gtm_item_price = itemBeingRemoved.querySelector('[name="gtm_item_price"]').getAttribute('value')
      const gtm_item_brand = itemBeingRemoved.querySelector('[name="gtm_item_brand"]')?.getAttribute('value') || ''
      const gtm_item_sku = itemBeingRemoved.querySelector('[name="gtm_item_sku"]')?.getAttribute('value')
      const gtm_item_group_id = itemBeingRemoved.querySelector('[name="gtm_item_group_id"]')?.getAttribute('value') || ''
      const gtm_item_category = itemBeingRemoved.querySelector('[name="gtm_item_category"]')?.getAttribute('value') || ''
      const gtmContent = {
        item_name: gtm_item_name,
        item_id: gtm_item_id,
        item_collection: '',
        item_variant: gtm_item_variant,
        item_upc: gtm_item_upc,
        item_price: gtm_item_price,
        quantity: qtyBeingRemoved,
      }

      if (window.shop_iso_code === 'DE') {
        Object.assign(gtmContent, {
          item_brand: gtm_item_brand,
          item_sku: gtm_item_sku,
          item_group_id: gtm_item_group_id,
          category: gtm_item_category
        })
      }
      if (itemBeingRemoved.getAttribute('data-pause-frame')) {
        // Pause item needs to be removed via this call because we need to expire the reservation first so it's available again and then removed from cart
        import('./pause-cart-countdown').then(async (module) => {
          await module.cartRemovePauseItem(this.dataset.index, itemBeingRemoved, variantBeingRemoved, qtyBeingRemoved, gtmContent, cartContainer)
        })
      } else {
        cartContainer.updateQuantity(this.dataset.index, 0, variantBeingRemoved, qtyBeingRemoved, gtmContent)
      }
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)
